/**
 * Entry point for all layout components.
 * This way the main.js will be cleaner.
 */
const ContentVideo = () => import(/* webpackChunkName: "content-video" */'./video/ContentVideo')
const EventLocations = () => import(/* webpackChunkName: "event-locations" */'./event-locations/EventLocations')
const MouseWheelAnimation = () => import(/* webpackChunkName: "mouse-wheel-animation" */'./MouseWheelAnimation')
const TitleIntro = () => import(/* webpackChunkName: "title-intro" */'./TitleIntro')
const ZvEventTeaser = () => import(/* webpackChunkName: "zv-event-teaser" */'./event/EventTeaser')
const ZvExpandable = () => import(/* webpackChunkName: "zv-expandable" */'./expandable/Expandable')
const ZvFullscreenVideo = () => import(/* webpackChunkName: "zv-fullscreen-video" */'./video/ZvFullscreenVideo')
const ZvMasthead = () => import(/* webpackChunkName: "zv-masthead" */'./masthead/ZvMasthead')
const ZvScrollTop = () => import(/* webpackChunkName: "zv-scroll-top" */'./scroll/ScrollTop')
const ZvSidebar = () => import(/* webpackChunkName: "zv-slideshow-control" */'./sidebar/Sidebar')
const ZvSlideshow = () => import(/* webpackChunkName: "zv-slideshow" */'./slideshow/Slideshow')
const ZvSlideshowControl = () => import(/* webpackChunkName: "zv-slideshow-control" */'./slideshow/SlideshowControl')
const ContactForm = () => import(/* webpackChunkName: "contact-form" */'./contact/ContactForm')
const BookingForm = () => import(/* webpackChunkName: "booking-form" */'./contact/BookingForm')
const DarksiteWarning = () => import(/* webpackChunkName: "darksite-warning" */'./darksite/Warning')
const ZvMap = () => import(/* webpackChunkName: "map-container" */'./map/MapContainer.vue')

export {
  ContentVideo,
  EventLocations,
  MouseWheelAnimation,
  TitleIntro,
  ZvEventTeaser,
  ZvExpandable,
  ZvFullscreenVideo,
  ZvMasthead,
  ZvScrollTop,
  ZvSidebar,
  ZvSlideshow,
  ZvSlideshowControl,
  ContactForm,
  BookingForm,
  DarksiteWarning,
  ZvMap,
}
